import { MenuItem, Order } from './order';
import { filter } from 'rxjs/operators';
import { Constants } from '../constants';
import * as moment from 'moment';

export class Account {
  company: string;
  token: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  ftp_username: string;
}

export class StoreData {
  order_app_toggle_tip: boolean;
  occasion_list_order: String;
  enable_catering_gate: boolean;
  catering_gate_code: string;
}
export class Store {
  disclaimer_from_time: any;
  disclaimer_show: any;
  pause_store: any;
  store_pause_time: any;
  store_pause_date_time: any;
  pause_store_whole_day: any;
  store_whole_day_pause_date_time: any;
  is_spot_field_mandatory: any;
  disclaimer_to_time(arg0: string, disclaimer_to_time: any) {
    throw new Error("Method not implemented.");
  }
  id: string;
  account: Account;
  store_name: string;
  store_number: number;
  address: string;
  city: string;
  state_geographic: string;
  zip_code: string;
  phone: string;
  sms_number: string;
  sms_webhook: string;
  time_zone: string;
  contact_name: string;
  has_order_time_now: boolean;
  has_order_time_later: boolean;
  has_order_occasion_pickup: boolean;
  has_order_occasion_delivery: boolean;
  has_order_occasion_dine_in: boolean;
  has_order_occasion_curbside: boolean;
  has_order_occasion_tableside: boolean;
  pickup_dine_in_lead_time: number;
  dine_in_lead_time: number;
  delivery_lead_time: number;
  enable_cash_payment: boolean;
  working: Map<number, WorkingDay>;
  url_slug: string;
  has_card_payment: boolean;
  // ENG-5609: when on, a guest whose verification code never arrives can still pay with a
  // card entered for that one order.
  allow_guest_checkout: boolean;
  default_view_text_order_menu: boolean;
  has_menu: boolean;
  enable_text_ordering: boolean;
  enable_pick_and_click_ordering: boolean;
  delivery_minimum: number;
  payment_gateway: string;
  dynamic_offer_url: string;
  toggle_tip: boolean;
  gmb_location_id: string;
  delivery_radius: number;
  feature_flag: Map<string, boolean>;
  // ENG-5252: {enabled, window_seconds, future_window_minutes} — drives the
  // delayed-submit hold countdown and the future-order cancel window.
  customer_order_cancel: any;
  storefront_theme: string;
  storefront_brand_color: string;
  storefront_dark_mode: boolean;
  storefront_corner_style: string;
  customer_photo_points: number;
  lead_times: any[];
  service_toggle: boolean;
  surcharge_percent: number;
  tip_percent_option: any[];
  last_order_buffer: Map<number, number>;
  occasion_flags: Map<string, boolean>;
  occasion_flags_online: Map<string, boolean>;
  payroc_username: string;
  service_charge_label: string;
  surcharge_label: string;
  service_charge_description: string;
  special_hour: any[];
  holiday_list: any[];
  delivery_charge: number;
  nmi_public_key: string;
  surcharge_text: string;
  enable_pos_pay_later: boolean;
  ui_settings: Map<string, boolean>
  show_menu_price: boolean;
  modules: string[];
  enable_pos_credit_service_charge_dollar: boolean;
  enable_online_credit_service_charge_dollar: boolean;
  surcharge_label_dollar: any;
  disclaimer_message: string;
  count_down_timer_color: string;
  store_description: string;
  real_time: string;
  store_data:StoreData;

  // Catering customization fields (backend-dependent, null-safe)
  catering_label: string;
  catering_icon: string;
  occasion_flags_catering: Map<string, boolean>;

  getCateringLabel(): string {
    return this.catering_label && this.catering_label.length > 0 ? this.catering_label : 'Catering Order';
  }

  getCateringIcon(): string {
    return this.catering_icon && this.catering_icon.length > 0 ? this.catering_icon : 'dining';
  }

  getOccasionFlags(isCatering: boolean): Map<string, boolean> {
    if (isCatering && this.occasion_flags_catering) {
      return this.occasion_flags_catering;
    }
    return this.occasion_flags_online;
  }

  hasModule(module) {
    return this.modules?.includes(module) || false
  }

  convertTZ(date) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: this.time_zone }));
  }

  isStoreOpened() {
    return this.is_open_now();
  }

  // Holiday_list
  getHolidayHours() {
    let today = moment().format("YYYY-MM-DD");
    let holiday = this.holiday_list.find(h => h.holiday_date === today);
    if (holiday) {
      let ret = holiday['hour'];
      if (!ret) {
        ret = this.getTodaysWorkingConfig();
      }
      ret['is_open'] = holiday['is_open'];
      return ret;
    } else {
      return null;
    }
  }

  getHoliday() {
    let today = moment().format("YYYY-MM-DD");
    let holiday = this.holiday_list.find(h => h.holiday_date === today);
    if (holiday) {
      return holiday.holiday_name;
    } else {
      return null;
    }
  }

  isStoreOpenedNeedFix() {
    var format = "hh:mm";
    let special_hour = this.getSpecialHours()
    let holiday_list = this.getHolidayHours();

    const currentDayIndex = moment().day();
    const previousDaySlot = this.getSlot(currentDayIndex - 2);

    const currentDaySlot = special_hour ? special_hour : holiday_list ? holiday_list : this.getSlot(currentDayIndex - 1);

    // converted currenttimezone according to required timezone in api response
    const convertedTimezone = this.convertTZ(new Date());

    //converted in a time format-"hh:mm"
    const currentTime = moment(convertedTimezone.getHours() + ":" + convertedTimezone.getMinutes(), format);
    const beforeTime_today = moment(currentDaySlot.from_hour + ":" + currentDaySlot.from_min, format);
    let afterTime_today = moment(currentDaySlot.to_hour + ":" + currentDaySlot.to_min, format);
    const beforeTime_previous = moment(previousDaySlot.from_hour + ":" + previousDaySlot.from_min, format);
    let afterTime_previous = moment(previousDaySlot.to_hour + ":" + previousDaySlot.to_min, format);

    //adding/substracting one day because closing time is of tommorrow(one day extra)
    if (afterTime_previous < beforeTime_previous) {
      afterTime_previous = moment(afterTime_previous, "DD-MM-YYYY").subtract(1, 'days');
    }
    if (afterTime_today < beforeTime_today) {
      afterTime_today = moment(afterTime_today, "DD-MM-YYYY").add(1, 'days');
    }

    if (currentTime.isBetween(beforeTime_previous, afterTime_previous)) {
      return true
    } else if (currentTime.isBetween(beforeTime_today, afterTime_today)) {
      return true;
    } else {
      return false;
    }
  }

  getServiceChargeLabel() {
    return this.service_charge_label && this.service_charge_label.length > 0 ? this.service_charge_label : 'Service Fee'
  }

  getSurchargeLabel() {
    if (this.enable_pos_credit_service_charge_dollar || this.enable_online_credit_service_charge_dollar) {
      return this.surcharge_label_dollar && this.surcharge_label_dollar.length > 0 ? this.surcharge_label_dollar : 'Surcharge'
    } else {
      return this.surcharge_label && this.surcharge_label.length > 0 ? this.surcharge_label : 'Surcharge'
    }
  }

  getTodayIndex() {
    let today = new Date()
    var dayIndex = today.getDay() - 1;
    if (dayIndex < 0) {
      dayIndex = 6;
    }
    return dayIndex;
  }

  getSpecialHours() {
    let today = moment().format("YYYY-MM-DD")
    // let special_date = this.special_hour.find(h => h.special_date === today)
    let special_date = this.special_hour.find(h => new Date(h.special_date) <= new Date(today) && new Date(today) <= new Date(h.special_end_date))
    if (special_date) {
      let ret = special_date['hour']
      if (!ret) {
        ret = this.getTodaysWorkingConfig()
      }
      ret['is_open'] = special_date['is_open']
      return ret
    } else {
      return null
    }
  }

  getSlot(dayIndex) {
    let workingHours = this.working && this.working[dayIndex]['hours']
    var slot;
    let now = new Date()

    console.log('Working hours', workingHours);
    
    if (workingHours?.length === 1) {

      const fr_Time = new Date();
      fr_Time.setHours(workingHours[0].from_hour, workingHours[0].from_min, 0, 0);
      const to_Time = new Date();
      to_Time.setHours(workingHours[0].to_hour, workingHours[0].to_min, 0, 0);

      if (this.working[dayIndex]['open_type'] !== 'CLOSED') {
        slot = workingHours[0]
        slot['day_index'] = dayIndex;

      } else {
        slot = this.findNextOpenSlot();
      }
    } else {
      if (this.working[dayIndex]['open_type'] !== 'CLOSED') {
        const todayIndex = now.getDay() - 1;
        if (dayIndex == todayIndex) {
          slot = workingHours.find(w => {
            const fromTime = new Date();
            fromTime.setHours(w.from_hour, w.from_min, 0, 0);
            const toTime = new Date();
            toTime.setHours(w.to_hour, w.to_min, 0, 0);
            if (now >= fromTime && now <= toTime) {
              return w
            } else if (now <= toTime) {
              return w
            } else if (now > toTime) {
              return
            }
          })
        }

        if (!slot) {
          slot = workingHours[workingHours.length - 1]
        }
        slot['day_index'] = dayIndex
      } else {
        slot = this.findNextOpenSlot();
      }
    }
    if (!slot) {
      return { is_open: false, from_hour: 0, from_min: 0, to_hour: 0, to_min: 0, day_index: dayIndex };
    }
    slot['is_open'] = this.working[dayIndex]['open_type'] !== 'CLOSED'
    return slot;
  }

  findNextOpenSlot() {
    const workingDays = Object.values(this.working);
    const today = new Date().getDay() - 1;
    let nextOpeningDay = null;
    let currentIndex = today + 1;
    let slot = null;

    for (; currentIndex !== today; currentIndex = (currentIndex + 1) % 7) {
      const nextDayIndex = currentIndex % 7;
      const nextDay = workingDays.find(day => day.day === nextDayIndex);
      if (nextDay && nextDay.open_type === 'OPEN') {
        nextOpeningDay = nextDay;
        const nextDayWorkingHour = this.working && this.working[nextDayIndex]['hours'];
        slot = nextDayWorkingHour[0];
        slot['day_index'] = nextOpeningDay.day;
        break;
      }
      if (nextDay && nextDay.open_type !== 'CLOSED') {
        break;
      }
    }

    return slot;
  }

  getYesterdaysWorkingConfig() {
    let today = new Date()
    var dayIndex = today.getDay() - 2;
    if (dayIndex < 0) {
      dayIndex = 6;
    }
    console.log('DAY Index', dayIndex);
    
    return this.getSlot(dayIndex)
  }

  getYesterdaysSpecialHours() {
    let yesterday = moment().subtract(1, 'days').format("YYYY-MM-DD")
    let special_date = this.special_hour.find(h =>
      new Date(h.special_date) <= new Date(yesterday) &&
      new Date(yesterday) <= new Date(h.special_end_date)
    )
    if (special_date) {
      let ret = special_date['hour']
      if (!ret) {
        ret = this.getYesterdaysWorkingConfig()
      }
      ret['is_open'] = special_date['is_open']
      return ret
    } else {
      return null
    }
  }

  getPreviousWorkingConfig(date) {
    var dayIndex = date.getDay() - 2;
    if (dayIndex < 0) {
      dayIndex = 5;
    }
    return this.getSlot(dayIndex)
  }

  getPreviousSpecialHours(date) {
    let yesterday = moment(date).subtract(1, 'days').format("YYYY-MM-DD")
    let special_date = this.special_hour.find(h =>
      new Date(h.special_date) <= new Date(yesterday) &&
      new Date(yesterday) <= new Date(h.special_end_date)
    )
    if (special_date) {
      let ret = special_date['hour']
      if (!ret) {
        ret = this.getPreviousWorkingConfig(date)
      }
      ret['is_open'] = special_date['is_open']
      return ret
    } else {
      return null
    }
  }

  getSpecialHoursOn(date) {
    let today = moment(date).format("YYYY-MM-DD")
    let special_date = this.special_hour.find(h =>
      new Date(h.special_date) <= new Date(today) &&
      new Date(today) <= new Date(h.special_end_date)
    )
    if (special_date) {
      let ret = special_date['hour']
      if (!ret) {
        ret = this.getTodaysWorkingConfig()
      }
      ret['is_open'] = special_date['is_open']
      return ret
    } else {
      return null
    }
  }


  getTodaysWorkingConfig() {
    let today = new Date()
    var dayIndex = today.getDay() - 1;
    if (dayIndex < 0) {
      dayIndex = 6;
    }
    return this.getSlot(dayIndex)
  }

  getWorkingConfigOn(date) {
    var dayIndex = date.getDay() - 1;
    if (dayIndex < 0) {
      dayIndex = 6;
    }
    return this.getSlot(dayIndex)
  }

  isAvailable() {
    return this.service_toggle
  }

  /** "Now" on the store's wall clock, expressed as a local Date (same convention as the slot math). */
  storeNow(): Date {
    if (!this.time_zone) { return new Date(); }
    try { return this.convertTZ(new Date()); } catch { return new Date(); }
  }

  /**
   * Convert a store wall-clock value (a local Date whose fields are store-local
   * hours/minutes) into the real instant in the store's time zone. Used when
   * sending a scheduled time to the backend so a customer browsing from
   * another time zone still books the time the store will read.
   */
  toStoreInstant(wall: Date): Date {
    if (!this.time_zone) { return new Date(wall); }
    const asUtc = Date.UTC(wall.getFullYear(), wall.getMonth(), wall.getDate(), wall.getHours(), wall.getMinutes(), 0, 0);
    let offset = this.tzOffsetMinutes(new Date(asUtc));
    let instant = asUtc - offset * 60000;
    const offset2 = this.tzOffsetMinutes(new Date(instant));
    if (offset2 !== offset) { instant = asUtc - offset2 * 60000; }
    return new Date(instant);
  }

  /** Offset (minutes east of UTC) of the store time zone at `at`. */
  private tzOffsetMinutes(at: Date): number {
    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: this.time_zone, hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(at);
      const get = (t: string) => +parts.find(x => x.type === t).value;
      const wallUtc = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour') % 24, get('minute'), get('second'));
      return Math.round((wallUtc - at.getTime()) / 60000);
    } catch {
      return -new Date().getTimezoneOffset();
    }
  }

  /** Hour slots ({from_hour, from_min, to_hour, to_min}) configured for a calendar day. Special hours win over regular. */
  private getDayHours(day: moment.Moment): any[] {
    const dateStr = day.format('YYYY-MM-DD');
    const special = (this.special_hour || []).find(h =>
      new Date(h.special_date) <= new Date(dateStr) && new Date(dateStr) <= new Date(h.special_end_date));
    if (special) {
      if (special.is_open === false) { return []; }
      if (special.hour) { return [special.hour]; }
      // special "open" with no hour restriction falls through to regular hours
    }
    let dayIndex = day.day() - 1;
    if (dayIndex < 0) { dayIndex = 6; }
    const cfg: any = this.working && this.working[dayIndex];
    if (!cfg || cfg.open_type === 'CLOSED') { return []; }
    if (cfg.open_type === '24_HOUR') { return [{ from_hour: 0, from_min: 0, to_hour: 0, to_min: 0 }]; }
    return cfg.hours || [];
  }

  private isClosedHoliday(day: moment.Moment): boolean {
    const dateStr = day.format('YYYY-MM-DD');
    const holiday = (this.holiday_list || []).find(h => h.holiday_date === dateStr);
    return !!holiday && holiday.is_open === false;
  }

  /**
   * Open windows (store wall clock as local Dates) that touch the calendar
   * date of `date`, including the after-midnight tail of the previous day's
   * overnight hours. Empty when the store is closed that day.
   */
  getOpenWindowsOn(date: Date): { from: Date, to: Date }[] {
    const day = moment(date).startOf('day');
    const windows: { from: Date, to: Date }[] = [];
    const push = (base: moment.Moment, h: any) => {
      if (!h) { return; }
      const from = base.clone().hour(+h.from_hour || 0).minute(+h.from_min || 0).second(0).millisecond(0);
      let to = base.clone().hour(+h.to_hour || 0).minute(+h.to_min || 0).second(0).millisecond(0);
      if (!to.isAfter(from)) { to = to.add(1, 'day'); } // overnight, or 24h expressed as 00:00-00:00
      windows.push({ from: from.toDate(), to: to.toDate() });
    };

    if (!this.isClosedHoliday(day)) {
      for (const h of this.getDayHours(day)) { push(day, h); }
    }

    const prev = day.clone().subtract(1, 'day');
    if (!this.isClosedHoliday(prev)) {
      for (const h of this.getDayHours(prev)) {
        const overnight = (+h.to_hour < +h.from_hour) ||
          (+h.to_hour === +h.from_hour && (+h.to_min || 0) <= (+h.from_min || 0));
        if (overnight) { push(prev, h); }
      }
    }
    return windows;
  }

  is_closed_for_the_day(date) {
    return this.getOpenWindowsOn(date).length === 0;
  }

  /**
   * Can an order be fulfilled at `date`? The slot must fall inside an open
   * window, leave `leadTime` minutes before closing, and be at least
   * `leadTime` minutes after now (store wall clock).
   */
  is_open_on(date, leadTime = 0) {
    const slot = moment(date);
    const lead = Math.max(0, +leadTime || 0);
    const earliest = moment(this.storeNow()).add(lead, 'minutes');
    if (slot.isBefore(earliest)) { return false; }
    return this.getOpenWindowsOn(slot.toDate()).some(w =>
      !slot.isBefore(w.from) && !slot.isAfter(moment(w.to).subtract(lead, 'minutes')));
  }


  // is_open_now() {
  //   let now = new Date()
  //   let yesterday_config = this.getYesterdaysWorkingConfig()
  //   let special_hour = this.getSpecialHours()
  //   let holiday_list = this.getHolidayHours()

  //   let fromDate = new Date();
  //   fromDate.setDate(fromDate.getDate() - 1); // Set to yesterday
  //   fromDate.setHours(yesterday_config.from_hour, yesterday_config.from_min, 0, 0);

  //   let toDate = new Date();
  //   toDate.setDate(toDate.getDate() - 1); // Set to yesterday
  //   toDate.setHours(yesterday_config.to_hour, yesterday_config.to_min, 0, 0);

  //   if (toDate < fromDate) {
  //     toDate.setDate(toDate.getDate() + 1); // Move to_date to the next day
  //   }
  //   let day_config = special_hour ? special_hour : holiday_list ? holiday_list : this.getTodaysWorkingConfig();

  //   const currentDayIndex = this.getTodayIndex();
  //   if (currentDayIndex == day_config.day_index) {
  //     let start = new Date()
  //     start.setHours(day_config.from_hour)
  //     start.setMinutes(day_config.from_min)
  //     let end = new Date()
  //     end.setHours(day_config.to_hour)
  //     end.setMinutes(day_config.to_min)
  //     if (end < start) {
  //       end.setDate(end.getDate() + 1);
  //     }

  //     const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //     if (toDate.toISOString().split('T')[0] === start.toISOString().split('T')[0]
  //       && toDate.getTime() <= start.getTime()) {

  //       if (now < toDate) {
  //         return yesterday_config.is_open && toDate > now && start > now && this.time_zone === systemTimezone;
  //       } else {
  //         return day_config.is_open && start <= now && end >= now && this.time_zone === systemTimezone;
  //       }
  //     }
  //     else {
  //       return day_config.is_open && start <= now && end >= now && this.time_zone === systemTimezone;
  //     }
  //   } else if (special_hour) {
  //     let start = new Date()
  //     start.setHours(day_config.from_hour)
  //     start.setMinutes(day_config.from_min)
  //     let end = new Date()
  //     end.setHours(day_config.to_hour)
  //     end.setMinutes(day_config.to_min)
  //     if (end < start) {
  //       end.setDate(end.getDate() + 1);
  //     }

  //     const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //     if (toDate.toISOString().split('T')[0] === start.toISOString().split('T')[0]
  //       && toDate.getTime() <= start.getTime()) {

  //       if (now < toDate) {
  //         return yesterday_config.is_open && toDate > now && start > now && this.time_zone === systemTimezone;
  //       } else {
  //         return day_config.is_open && start <= now && end >= now && this.time_zone === systemTimezone;
  //       }
  //     }
  //     else {
  //       return day_config.is_open && start <= now && end >= now && this.time_zone === systemTimezone;
  //     }
  //   } else {
  //     return false
  //   }

  // }

  /**
   * Is the store open right now? Evaluated on the store's own clock, so a customer browsing
   * from another time zone sees the same answer as someone standing in the store. The old
   * version returned false whenever the browser time zone differed from the store's, which
   * forced those customers into "Schedule for Later" and hid the ASAP option.
   */
  is_open_now() {
    const now = this.storeNow();
    return this.getOpenWindowsOn(now).some(w => now >= w.from && now <= w.to);
  }

  createDateFromConfig(hour, minute, daysOffset = 0) {
    let baseDate = this.real_time ? new Date(this.real_time) : new Date();
    let date = new Date(baseDate);
    date.setDate(date.getDate() + daysOffset);
    date.setHours(hour, minute, 0, 0);
    return date;
  }

  resolveSpecialHourConfig(special_hour, now, defaultConfig) {
    if (!special_hour.is_open) {
      return defaultConfig;
    }
    let special_start = this.createDateFromConfig(special_hour.from_hour, special_hour.from_min);
    let special_end = this.createDateFromConfig(special_hour.to_hour, special_hour.to_min);

    if (special_start <= now && special_end >= now) {
      return special_hour;
    } else {
      return defaultConfig;
    }
  }

  isWithinWorkingHours(day_config, now, toDate, yesterday_config, systemTimezone) {
    let start = this.createDateFromConfig(day_config.from_hour, day_config.from_min);
    let end = this.createDateFromConfig(day_config.to_hour, day_config.to_min);

    if (end < start) {
      end.setDate(end.getDate() + 1); // Adjust if crossing midnight
    }

    if (toDate.toISOString().split('T')[0] === start.toISOString().split('T')[0] &&
      toDate.getTime() <= start.getTime()) {
      if (now < toDate) {
        return yesterday_config.is_open && toDate > now && start > now && this.time_zone === systemTimezone;
      } else {
        return day_config.is_open && start <= now && end >= now && this.time_zone === systemTimezone;
      }
    } else {
      return day_config.is_open && start <= now && end >= now && this.time_zone === systemTimezone;
    }
  }

  /**
   * Store-configured lead time (minutes) for an occasion: the base pickup /
   * delivery lead time, overridden by a custom lead-time window that is
   * active at `at` (defaults to now on the store wall clock).
   */
  getLeadTime(occasion, at?: Date): number {
    let leadTime = 0;
    if (occasion === 'PICKUP' || occasion === 'CURBSIDE') {
      leadTime = this.pickup_dine_in_lead_time;
    } else if (occasion === 'DELIVERY') {
      leadTime = this.delivery_lead_time;
    } else if (occasion === 'DINE IN') {
      leadTime = this.dine_in_lead_time ?? this.pickup_dine_in_lead_time;
    }
    leadTime = +leadTime || 0;

    const now = at ? new Date(at) : this.storeNow();
    let dayIndex = now.getDay() - 1;
    if (dayIndex < 0) { dayIndex = 6; }
    const occasionCode = Constants.occasionRi[occasion];
    const custom: any[] = (this.lead_times || []).filter(x => x.day === dayIndex && x.occasion === occasionCode);
    custom.forEach(lt => {
      const start = new Date(now); start.setHours(+lt.from_hour, +lt.from_min || 0, 0, 0);
      const end = new Date(now); end.setHours(+lt.to_hour, +lt.to_min || 0, 0, 0);
      if (start <= now && end >= now) { leadTime = +lt.lead_time || leadTime; }
    });
    return leadTime;
  }

  /**
   * Minutes between the store's clock and a backend-stamped occasion_schedule
   * (the "ASAP in N mins" figure). null when either side is missing.
   */
  getScheduledLeadMinutes(occasion_schedule): number | null {
    if (!occasion_schedule || !this.real_time) { return null; }
    const realTimeDate = new Date(this.real_time.replace(' ', 'T'));
    const scheduleDate = new Date(occasion_schedule);
    if (isNaN(realTimeDate.getTime()) || isNaN(scheduleDate.getTime())) { return null; }
    realTimeDate.setSeconds(0, 0);
    scheduleDate.setSeconds(0, 0);
    return Math.round((scheduleDate.getTime() - realTimeDate.getTime()) / 60000);
  }

  /** Lead time to show on the ASAP label: backend-stamped when available, else the store setting. */
  getAsapLeadTime(occasion, occasion_schedule): number {
    const stamped = this.getScheduledLeadMinutes(occasion_schedule);
    return stamped !== null && stamped >= 0 ? stamped : this.getLeadTime(occasion);
  }

  /** Time after which `occasion` orders stop for today (closing time minus the last-order buffer), or null. */
  lastOrderCutoff(occasion: string): Date | null {
    const buffer = +((this.last_order_buffer as any)?.[occasion] ?? 0);
    if (!(buffer > 0)) return null;
    const closing = this.getClosingHours();
    if (!closing) return null;
    return moment(closing).subtract(buffer, 'minutes').toDate();
  }

  isPastLastOrderCutoff(occasion: string): boolean {
    const cutoff = this.lastOrderCutoff(occasion);
    return !!cutoff && new Date() >= cutoff;
  }

  /** Earliest last-order cutoff across order types, for the menu header; `passed` when already behind us. */
  nextLastOrderCutoff(): { occasion: string, cutoff: Date, passed: boolean } | null {
    const buffers: any = this.last_order_buffer || {};
    const entries = Object.keys(buffers)
      .map(o => ({ occasion: o, cutoff: this.lastOrderCutoff(o) }))
      .filter(e => !!e.cutoff)
      .sort((a, b) => a.cutoff.getTime() - b.cutoff.getTime());
    if (!entries.length) return null;
    const first = entries[0];
    return { occasion: first.occasion, cutoff: first.cutoff, passed: new Date() >= first.cutoff };
  }

  getClosingHours() {
    let now = this.real_time ? new Date(this.real_time) : new Date();
    let yesterday_regular_config = this.getYesterdaysWorkingConfig()
    let yesterday_special_hours = this.getYesterdaysSpecialHours()
    // Use yesterday's special hours if they exist, otherwise use regular hours
    let yesterday_config = yesterday_special_hours ? yesterday_special_hours : yesterday_regular_config
    let special_hour = this.getSpecialHours()
    let holiday_list = this.getHolidayHours()
    let day_config = special_hour ? special_hour : holiday_list ? holiday_list : this.getTodaysWorkingConfig();

    /* NEW */
    // if (special_hour && !special_hour.is_open) {
    //   day_config = this.getTodaysWorkingConfig();
    // } else if (special_hour && special_hour.is_open) {
    //   let special_start = new Date()
    //   special_start.setHours(day_config.from_hour)
    //   special_start.setMinutes(day_config.from_min)
    //   let special_end = new Date()
    //   special_end.setHours(day_config.to_hour)
    //   special_end.setMinutes(day_config.to_min)

    //   if (special_start <= now && special_end >= now) { } else {
    //     day_config = this.getTodaysWorkingConfig();
    //   }
    // }

    /* OLD */
    if (special_hour) {
      let special_start = new Date()
      special_start.setHours(day_config.from_hour)
      special_start.setMinutes(day_config.from_min)
      let special_end = new Date()
      special_end.setHours(day_config.to_hour)
      special_end.setMinutes(day_config.to_min)
    }

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 1); // Set to yesterday
    fromDate.setHours(yesterday_config.from_hour, yesterday_config.from_min, 0, 0);

    let toDate = new Date();
    toDate.setDate(toDate.getDate() - 1); // Set to yesterday
    toDate.setHours(yesterday_config.to_hour, yesterday_config.to_min, 0, 0);

    if (toDate < fromDate) {
      toDate.setDate(toDate.getDate() + 1); // Move to_date to the next day
    }

    let start = new Date()
    start.setHours(day_config.from_hour)
    start.setMinutes(day_config.from_min)

    let end = new Date()
    end.setHours(day_config.to_hour)
    end.setMinutes(day_config.to_min)
    if (end < start) {
      end.setDate(end.getDate() + 1);
    }
    // / New Condition /
    if (toDate.toISOString().split('T')[0] === start.toISOString().split('T')[0]
      && toDate.getTime() <= start.getTime()) {
      if (now < toDate) {
        return toDate
      } else {
        return end
      }
    } else {
      return end
    }
  }

  getOpeningHours() {
    let now = this.real_time ? new Date(this.real_time) : new Date();
    let special_hour = this.getSpecialHours()
    let holiday_list = this.getHolidayHours()
    let day_config = special_hour ? special_hour : holiday_list ? holiday_list : this.getTodaysWorkingConfig();

    /* NEW */
    // if (special_hour && !special_hour.is_open) {
    //   day_config = this.getTodaysWorkingConfig();
    // } else if (special_hour && special_hour.is_open) {
    //   let special_start = new Date()
    //   special_start.setHours(day_config.from_hour)
    //   special_start.setMinutes(day_config.from_min)
    //   let special_end = new Date()
    //   special_end.setHours(day_config.to_hour)
    //   special_end.setMinutes(day_config.to_min)

    //   if (special_start <= now && special_end >= now) { } else {
    //     day_config = this.getTodaysWorkingConfig();
    //   }
    // }

    /* OLD */
    if (special_hour) {
      let special_start = new Date()
      special_start.setHours(day_config.from_hour)
      special_start.setMinutes(day_config.from_min)
      let special_end = new Date()
      special_end.setHours(day_config.to_hour)
      special_end.setMinutes(day_config.to_min)
    }

    const toTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), day_config.to_hour, day_config.to_min, 0);
    const fromTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), day_config.from_hour, day_config.from_min, 0);
    let today_config;
    if (now > fromTime && toTime <= now) {
      if (special_hour) {
        today_config = this.getTodaysWorkingConfig();
      } else {
        today_config = day_config
      }
      const dayconfig = this.getSlot((today_config.day_index + 1) % 7);
      now.setDate(now.getDate() + 1)
      now.setHours(dayconfig.from_hour)
      now.setMinutes(dayconfig.from_min)
      return now
    } else {
      if (!day_config.is_open) {
        if (special_hour) {
          today_config = this.getTodaysWorkingConfig();
        } else {
          today_config = day_config
        }
        const dayconfig = this.getSlot((today_config.day_index + 1) % 7);
        now.setDate(now.getDate() + 1)
        now.setHours(dayconfig.from_hour)
        now.setMinutes(dayconfig.from_min)
        return now
      } else {
        now.setDate(now.getDate() + 1)
        now.setHours(day_config.from_hour)
        now.setMinutes(day_config.from_min)
        return now
      }
      
    }

  }

  isEnabled(flag) {
    return flag in this.feature_flag && this.feature_flag[flag]
  }

  hasCurbsideOnly() {
    return this.has_order_occasion_curbside
      && !this.has_order_occasion_delivery
      && !this.has_order_occasion_dine_in
      && !this.has_order_occasion_pickup;
  }

  hasFutureOrderEnabled(){
    return this.isEnabled('future_order') && this.isEnabled('future_order');
  }

  /**
   * Scheduled ("future") orders are offered only while Service is on. The item sheet and the
   * checkout used to check the future_order flag alone, so a store that switched Service off
   * kept taking scheduled orders outside its hours (Wicked Bagel Watertown, 2026-10-30).
   */
  canScheduleOrders() {
    return this.hasFutureOrderEnabled() && this.isAvailable();
  }

  isTodayHoliday() {
    let today = moment().format("YYYY-MM-DD");
    return this.holiday_list.some(h => h.holiday_date === today);
  }

  getCurrentSlot() {
    if (this.isTodayHoliday()) {
      return this.getHolidayHours();
    } else if (this.getSpecialHours()) {
      return this.getSpecialHours();
    } else {
      return this.getTodaysWorkingConfig();
    }
  }

  updateHolidayStatus(date: string, isOpen: boolean, from_hour: number, from_min: number, to_hour: number, to_min: number) {
    let holiday = this.holiday_list.find(h => h.holiday_date === date);
    if (holiday) {
      holiday.is_open = isOpen;
      holiday.hour = {
        from_hour: from_hour,
        from_min: from_min,
        to_hour: to_hour,
        to_min: to_min
      };
    } else {
      this.holiday_list.push({
        holiday_date: date,
        is_open: isOpen,
        hour: {
          from_hour: from_hour,
          from_min: from_min,
          to_hour: to_hour,
          to_min: to_min
        }
      });
    }
  }
}

export class WorkingDay {
  is_open: boolean;
  from_hour: number;
  from_min: number;
  to_hour: number;
  to_min: number;
  constructor(is_open: boolean, from_hour: number, from_min: number, to_hour: number, to_min: number) {
    this.is_open = is_open
    this.from_hour = from_hour
    this.from_min = from_min
    this.to_hour = to_hour
    this.to_min = to_min
  }
}

export class StoreMenuGroup {
  group_name: string;
  items: MenuItem[];
}
export class StoreMenuItems {
  menu_items: StoreMenuGroup[];
  store: Store;
  menu_order: string[];
}

export class MenuItemGroup {
  id: number;
  name: string;
  description: string;
  starting_price: number;
  image: string;
  hide_from_online_ordering: boolean;
  show_on_catering_menu: boolean;
}
export class StoreMenuItemsV2 {
  menu_items: Map<string, MenuItemGroup>;
  store: Store;
  menu_order: string[];
}

export interface Table {
  id: number;
  table_name: string;
}

export interface StoreLite {
  id: number;
  store_name: string;
}
